import dayjs from "dayjs";
import { t } from "i18next";

function formatDate(dateString) {
  if (!dateString) return;
  const date = dayjs(dateString);
  return date.format(t("human_format.date"));
}

export default formatDate;
